import { ChangeDetectionStrategy, Compiler, Component, Injector, Input, OnInit } from '@angular/core';

import { IngestQueueComponent } from './ingest-queue.component';
import { EDGE_ID, ARRIVALS_ID, ENDPOINT_ID, ACCOUNT_ID, PAGE_MODE, THUMB_SIZE } from '../media-manager/ng/media-manager/services/grid-only.token';

// This XXXPageComponent exists as a lazy-loading mechanism for a page's module while we
// are in MPA structure and cannot therefore use Angular's router.
@Component({
   selector: 'bb-ingest-queue-page',
   template: `
      <div *ngIf="loaded">
         <!-- Once loaded, instantiate the component (start the component tree here) -->
         <ng-container *ngComponentOutlet="component; injector: ingestInjector"></ng-container>
      </div>
   `,
   styles: [':host { display: block; }'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class IngestQueuePageComponent implements OnInit {
   @Input() edgeId: string | undefined;
   @Input() arrivalsId: string | undefined;
   @Input() endpointId: string | undefined;
   @Input() accountId: string | undefined;
   @Input() mode: string | undefined;
   @Input() thumbSize: string | undefined;

   public loaded = false;
   public component: typeof IngestQueueComponent;
   public ingInjector: Injector;
   public ingestInjector: Injector;

   constructor(
      private compiler: Compiler,
      private injector: Injector,
   ) {}

   async ngOnInit() {
      // Create an injector with the desired values
      this.ingestInjector = Injector.create({
         providers: [{ provide: EDGE_ID, useValue: this.edgeId }, { provide: ARRIVALS_ID, useValue: this.arrivalsId }, { provide: ENDPOINT_ID, useValue: this.endpointId}, { provide: ACCOUNT_ID, useValue: this.accountId }, { provide: PAGE_MODE, useValue: this.mode }, { provide: THUMB_SIZE, useValue: this.thumbSize }],
         parent: this.injector
      });
      /* Statically import the page's module.
       * This import() statement will be parsed by Angular's static analysis during the build and
       * generate the module bundle. Angular inserts the module script into the HTML at runtime
       * (does not appear as a script tag in our HTML, or in the dist index.html).
       * https://angular.io/guide/lazy-loading-ngmodules
       * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-4.html#dynamic-import-expressions
       */
      const { IngestQueueAppModule: module } = await import('./ingest-queue-app.module');
      // Grab the root component of the page's component tree
      this.component = module.rootComponent;
      const factory = await this.compiler.compileModuleAsync(module);
      // Instantiate the module with the Angular injector
      factory.create(this.injector);
      this.loaded = true;
   }
}
